"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportSource = exports.isValidSource = exports.sourceToAccount = void 0;
const accounts_1 = require("viem/accounts");
const error_1 = require("../utils/error");
function sourceToAccount(source) {
    if ('privateKey' in source) {
        return (0, accounts_1.privateKeyToAccount)((0, error_1.assertHex)(source.privateKey, 'privateKey'));
    }
    else {
        return (0, accounts_1.mnemonicToAccount)(source.mnemonic);
    }
}
exports.sourceToAccount = sourceToAccount;
function isValidSource(source) {
    if ('privateKey' in source) {
        return true;
    }
    else if ('mnemonic' in source) {
        return true;
    }
    return false;
}
exports.isValidSource = isValidSource;
function exportSource(source) {
    if ('privateKey' in source) {
        return {
            privateKey: source.privateKey,
        };
    }
    return {
        mnemonic: source.mnemonic,
    };
}
exports.exportSource = exportSource;
